export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_00.be2d44c9.jpg";